import React from "react";
import { Box, Card, Typography, Stack } from "@mui/material";
import ConstructionOutlinedIcon from "@mui/icons-material/ConstructionOutlined";
import ClientDashboardLayout from "./ClientDashboardLayout";

export default function UnderConstructionPage({
  title = "Under Construction",
  description = "This page is being rebuilt for the new experience.",
}) {
  return (
    <ClientDashboardLayout title={title}>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          px: { xs: 2, md: 3 },
          py: { xs: 3, md: 4 },
        }}
      >
        <Card
          sx={{
            width: "100%",
            maxWidth: 760,
            borderRadius: 3,
            border: "1px solid #E2E6EF",
            boxShadow: "0 10px 24px rgba(15,23,42,0.08)",
            p: { xs: 3, md: 4 },
          }}
        >
          <Stack spacing={1.25} alignItems="center" textAlign="center">
            <ConstructionOutlinedIcon sx={{ fontSize: 44, color: "#536DEC" }} />
            <Typography
              sx={{
                fontFamily: '"Rethink Sans"',
                fontSize: { xs: 22, md: 26 },
                fontWeight: 700,
                color: "rgba(23, 25, 35, 0.90)",
              }}
            >
              {title}
            </Typography>
            <Typography
              sx={{
                fontFamily: '"Rethink Sans"',
                fontSize: { xs: 14, md: 16 },
                color: "rgba(23, 25, 35, 0.65)",
                maxWidth: 520,
              }}
            >
              {description}
            </Typography>
          </Stack>
        </Card>
      </Box>
    </ClientDashboardLayout>
  );
}
